<template>
  <td class="text-xs-right">{{ $t(value) }}</td>
</template>

<script>
export default {
  props: ['value']
}
</script>
